import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 10 10",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 5.00009,
		cy: 5.00009,
		r: 4.09091,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", { d: "M4.99967 0.833252C2.69967 0.833252 0.833008 2.69992 0.833008 4.99992C0.833008 7.29992 2.69967 9.16659 4.99967 9.16659C7.29967 9.16659 9.16634 7.29992 9.16634 4.99992C9.16634 2.69992 7.29967 0.833252 4.99967 0.833252ZM3.87051 6.78742L2.37467 5.29159C2.21217 5.12909 2.21217 4.86659 2.37467 4.70409C2.53717 4.54159 2.79967 4.54159 2.96217 4.70409L4.16634 5.90409L7.03301 3.03742C7.19551 2.87492 7.45801 2.87492 7.62051 3.03742C7.78301 3.19992 7.78301 3.46242 7.62051 3.62492L4.45801 6.78742C4.29967 6.94992 4.03301 6.94992 3.87051 6.78742Z" })]
});
export default SvgSuccess;
